import React from 'react';
import swal from 'sweetalert';
import { uploadTermsFile, getAuction } from '../../../../../../models/auctions';
import { Spinner } from 'react-bootstrap';
import i18n from '../../../../../../i18n';
import FileInput from '../../../../../helpers/fileInput';
import { FileText, Download } from 'lucide-react';

export class TermsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auction: {},
      is_loading: false,
      is_loading_terms: false,
      is_loading_terms_pay: false,
      auctionId: props.auctionId,
      file_terms: null,
      file_payment_terms: null,
    };
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidMount() { this.loadAuction(); }

  onFileChange = (event) => {
    if (event.target.files[0].name.split('.').pop().toLowerCase() !== 'pdf') {
      swal('Failed', 'Wrong file format', 'error');
      return;
    }
    if (event.target.name === 'file_terms') {
      this.setState({ file_terms: event.target.files[0] });
      this.uploadFile(event, 'T');
    }
    if (event.target.name === 'file_payment_terms') {
      this.setState({ file_payment_terms: event.target.files });
      this.uploadFile(event, 'P');
    }
  };

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    if (response) {
      this.setState({ auction: response.data, is_loading: false });
    }
  }

  async uploadFile(event, fileType) {
    event.preventDefault();
    if (!this.state.auctionId || !event.target.files[0].name) {
      swal('Failed', 'File Missing', 'error'); return;
    }
    const formData = new FormData();
    if (fileType === 'T') {
      this.setState({ is_loading_terms: true });
      formData.append('file_terms', event.target.files[0], event.target.files[0].name);
    }
    if (fileType === 'P') {
      this.setState({ is_loading_terms_pay: true });
      formData.append('file_payment_terms', event.target.files[0], event.target.files[0].name);
    }
    formData.append('auction_id', this.state.auctionId);
    formData.append('type', fileType);
    const response = await uploadTermsFile(formData);
    if (response) {
      if (fileType === 'P') this.setState({ is_loading_terms_pay: false });
      if (fileType === 'T') this.setState({ is_loading_terms: false });
      if (response.success) {
        this.setState({ auction: response.data });
      } else {
        swal('Failed', 'Some error occured!! Please make sure that you are uploading valid file.', 'error');
      }
    }
  }

  renderUploadCard(title, fileKey, loadingKey, inputName) {
    let { auction } = this.state;
    return (
      <div className="form-section">
        <h2><FileText size={20} style={{ marginRight: '8px', verticalAlign: 'text-bottom' }} />{title}</h2>
        <p style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '16px' }}>Allowed Formats: .pdf only</p>
        <div className="form-field form-field-margin-bottom">
          <FileInput className="form-control" placeholder={i18n.t('choose_file')}
            default_placeholder={i18n.t('choose_file')} id={inputName}
            name={inputName} onChange={this.onFileChange} />
        </div>

        {this.state[loadingKey] && (
          <div style={{ textAlign: 'center', padding: '1rem', background: '#f9fafb', borderRadius: '8px' }}>
            <Spinner animation="border" />
          </div>
        )}

        {!this.state[loadingKey] && auction[fileKey] && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px',
            background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb'
          }}>
            <FileText size={20} style={{ color: '#6b7280' }} />
            <a href={auction[fileKey]} target="_new" style={{
              color: '#10b981', fontWeight: 500, textDecoration: 'none', display: 'flex',
              alignItems: 'center', gap: '6px'
            }}>
              <Download size={16} /> {i18n.t('view')}/{i18n.t('download')}
            </a>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="form-content" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div>{this.renderUploadCard('Terms and Conditions', 'file_terms', 'is_loading_terms', 'file_terms')}</div>
        <div>{this.renderUploadCard('Payment Terms', 'file_payment_terms', 'is_loading_terms_pay', 'file_payment_terms')}</div>
      </div>
    );
  }
}